import React from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

// Height calculation: py-2 (16px padding) + content height (~20px for text) ≈ 36px
export const EXIT_FULL_SCREEN_OVERLAY_HEIGHT = 36;

interface ExitFullScreenOverlayProps {
  onExit: () => void;
  className?: string;
}

export const ExitFullScreenOverlay: React.FC<ExitFullScreenOverlayProps> = ({
  onExit,
  className,
}) => {
  return (
    <div
      onClick={onExit}
      className={cn(
        "absolute top-0 left-0 right-0 z-50",
        "bg-primary-0 text-white hover:bg-primary-100",
        "flex items-center justify-center",
        "px-4 py-2",
        "shadow-lg",
        "cursor-pointer",
        "transition-colors duration-150",
        className,
      )}
    >
      <div className="flex items-center">
        <span className="text-sm">Exit to Design on Canvas</span>
      </div>
    </div>
  );
};
